module.exports = __webpack_public_path__ + "img/ch12_02_敲门惊喜.39124c18.jpg";